import Team01 from '../../../img/team-2025/team-1.jpg'
import Team02 from '../../../img/team-2025/team-2.jpg'
import Team03 from '../../../img/team-2025/team-3.jpg'
import Team05 from '../../../img/team-2025/team-5.jpg'
import Team06 from '../../../img/team-2025/team-6.jpg'
import Team08 from '../../../img/team-2025/team-8.jpg'
import Team09 from '../../../img/team-2025/team-9.jpg'
import Team13 from '../../../img/team-2025/team-13.jpg'
import Team18 from '../../../img/team-2025/team-18.jpg'
import Team22 from '../../../img/team-2025/team-22.jpg'
import Team24 from '../../../img/team-2025/team-24.jpg'
import Team25 from '../../../img/team-2025/team-25.jpg'
import Team26 from '../../../img/team-2025/team-26.jpg'
import Team27 from '../../../img/team-2025/team-27.jpg'
import Team28 from '../../../img/team-2025/team-28.jpg'
import Team29 from '../../../img/team-2025/team-29.jpg'
import Team30 from '../../../img/team-2025/team-30.jpg'
/* ================= MAESTRAS ====================== */
import Teacher01 from '../../../img/inclu-2022/0r.jpg'
import Teacher02 from '../../../img/inclu-2022/01.jpg'
import Teacher03 from '../../../img/inclu-2022/1.jpg'
import Teacher04 from '../../../img/inclu-2022/2.jpg'
import Teacher05 from '../../../img/inclu-2022/3.jpg'
import Teacher06 from '../../../img/inclu-2022/4.jpg'
import Teacher07 from '../../../img/inclu-2022/5.jpg'
import Teacher08 from '../../../img/inclu-2022/6.jpg'
import Teacher09 from '../../../img/inclu-2022/7.jpg'
import Teacher10 from '../../../img/inclu-2022/8.jpg'
import Teacher11 from '../../../img/inclu-2022/9.jpg'
import Teacher12 from '../../../img/inclu-2022/11.jpg'
import Teacher13 from '../../../img/inclu-2022/12.jpg'
import Teacher14 from '../../../img/inclu-2022/13.jpg'
import Teacher15 from '../../../img/inclu-2022/14.jpg'
import Teacher16 from '../../../img/inclu-2022/15.jpg'
import Teacher17 from '../../../img/inclu-2022/16.jpg'
import Teacher18 from '../../../img/inclu-2022/18.jpg'
import Teacher19 from '../../../img/inclu-2022/20.jpg'

import { iTeamMember } from 'standardTypes'


const  TeamAssets2025: Array<iTeamMember> = [
        {
            image: Team02,
            alt: 'Team member',
            words: 'En RAYCES nos guía la búsqueda de un abordaje terapéutico que permita intervenir de manera integral en los diferentes aspectos cognitivos y socio-emocionales de los niños con dificultades de aprendizaje. Es importante generar experiencias positivas de aprendizaje de las que se desprendan estrategias para que los niños puedan incorporarlas y emplearlas en los diferentes contextos. De este modo reforzamos su autoestima en un ambiente de alegría para que se sientan más capaces al enfrentar nuevos desafíos.  Consideramos fundamental orientar, contener y apoyar a la familia y a la escuela para que actúen como facilitadores del proceso aprendizaje, contribuyendo a la felicidad y al desarrollo de las potencialidades del niño',
            memberName: 'Lic. María de Elía Cavanagh',
            memberRole: 'Psicopedagóga',
            memberTitle: 'Directora - Coordinadora Inclusión',
            showOrder: 1,
            type: 'team',
        },
        {
            image: Team01,
            alt: 'Team member',
            words: 'El lenguaje como capacidad innata de significar a través de cualquier código de signos, permite comunicar, expresar, comprender, simbolizar, pensar y constituirse como sujetos. Más allá de las definiciones y conceptos en cuanto a la estimulación y desarrollo del lenguaje, el compromiso, la cooperación, el respeto y la pasión en el trabajo con el niño y su familia, son valores que diariamente nos inspiran y se transforman en aprendizajes exitosos',
            memberName: 'Lic. Julieta Dip Torres',
            memberRole: 'Fonoaudióloga',
            memberTitle: 'Directora - Coordinadora Inclusión',
            showOrder: 2,
            type: 'team',
        },
        {
            image: Team03,
            alt: 'Team member',
            words: 'En RAYCES buscamos acompañar y orientar, de forma integral y de manera conjunta con la escuela y la familia, a los niños en sus trayectorias del aprendizaje. Poder hacer foco en sus fortalezas y logros para así llegar a la autonomía y ser los protagonistas de sus experiencias. Juntos lograr que las mismas sean positivas y permitan al niño explorar y aprender con alegría y entusiasmo.',
            memberName: 'Lic. Ana Inés Lagrotteria',
            memberRole: 'Psicopedagóga',
            memberTitle: 'Profesional - Rayces',
            showOrder: 3,
            type: 'team',
        },
        {
            image: Team05,
            alt: 'Team member',
            words: 'Acompañar, sostener, guiar,escuchar, movilizar aprendizajes, buscar vías alternativas para la recepción y transmisión de informacion...son algunas de las acciones profesionales que intentamos llevar a cabo de manera interdisciplnaria en Rayces. Aprender a comunicar(se) supone un gran desafío para algunas personas y, en lo personal, mi desafío es acompañar ese proceso de búsqueda de los recursos con los que cada niño cuenta y potenciarlo respetando su singularidad y la de su familia.',
            memberName: 'Lic. Diana García Albesa',
            memberRole: 'Fonoaudióloga',
            memberTitle: 'Profesional - Rayces',
            showOrder: 4,
            type: 'team',
        },
        {
            image: Team06,
            alt: 'Team member',
            words: 'El aprendizaje es un proceso sistemático y asistemático que se desarrolla a lo largo de toda la vida. Cada ser humano, como ser único e irrepetible transita este proceso de manera y en tiempos distintos, es por ello, que debemos detenernos en lapeculiaridad de cada sujeto con el objetivo de estimular debilidades y desarrollar fortalezas. Es primordial tener en cuenta el entorno y contexto cultural, la participacion de la familia, las institiciones escolares y la comunidad.',
            memberName: 'Lic. Gabriela Inés Heredia',
            memberRole: 'Psicopedagóga',
            memberTitle: 'Profesional - Rayces',
            showOrder: 5,
            type: 'team',
        },
        {
            image: Team08,
            alt: 'Team member',
            words: 'Basado en una visión global de la persona, el término «psicomotricidad» integra las interacciones cognitivas, emocionales, simbólicas y sensorio motrices en la capacidad de ser y de expresarse en un contexto psicosocial. Lapsicomotricidad, así definida, desempeña un papel fundamental en el desarrolloarmónico de la personalidad”. Desde el área de Psicomotricidad proponemos, como objetivo general,brindar un espacio en donde se pueda desarrollar o restablecer, mediante unabordaje corporal, el movimiento, la postura, la acción y el gesto, las capacidades del individuo.Pretendemos llegar por la vía corporal al desarrollo de las diferentesaptitudes y potencialidades del sujeto en todos sus aspectos motor, afectivosocial, comunicativo-lingüístico, intelectual-cognitivo.',
            memberName: 'Lic. Julia Veneranda',
            memberRole: 'Psicomotricista',
            memberTitle: 'Profesional - Rayces',
            showOrder: 6,
            type: 'team',
        },
        {
            image: Team09,
            alt: 'Team member',
            words: 'En mis años de trabajo y cómo parte del equipo de rayces fui descubriendo que hacer psicoeducacion no solo era poder conceptualizar un diagnóstico, sino que también  trata de los procesos intervinientes y sobre el tratamiento adecuado. En rayces trabajamos en poder educar, informar y brindarles las herramientas necesarias a la persona (niño/a, adolescentes y adulto que recibió un diagnóstico) como a su entorno sobre las características de su patología y cómo intervenir para su mejor calidad de vida , lograr su autonomía. Que el niño/a y su familia se sientan acompañados en nuestro objetivo.',
            memberName: 'Lic. Lorena Nieva',
            memberRole: 'Psicopedagóga',
            memberTitle: 'Profesional - Rayces',
            showOrder: 7,
            type: 'team',
        },
        {
            image: Team13,
            alt: 'Team member',
            words: '“Se habla a menudo del juego como si se tratara de un descanso del aprendizaje serio. Pero para los niños el juego es parte fundamental del aprendizaje serio. El juego, es realmente el trabajo de la infancia” Fred Rogers. En Rayces buscamos desarrollar oportunidades de aprendizajes y de crecimiento a través de situaciones lúdicas, en donde a partir de las habilidades e intereses de cada niño, ayudamos a alcanzar los desafíos que pueden llegar a presentar en las diferentes áreas de desarrollo. La comunicación y el trabajo articulado con la familia de cada niño, caracteriza nuestro trabajo en rayces, entendiendo que es la mejor manera de contribuir al desarrollo y generalización de los aprendizajes.',
            memberName: 'Lic. Priscila Tarifa',
            memberRole: 'Psicóloga',
            memberTitle: 'Profesional - Rayces',
            showOrder: 8,
            type: 'team',
        },
        {
            image: Team18,
            alt: 'Team member',
            words: 'Mi trabajo como terapeuta de la comunicación humana  tiene como objetivo acompañar el desarrollo del lenguaje, habilitar o  rehabilitar. El abordaje de la comunicación  puede iniciarse desde las etapas más  tempranas hasta la adultez. "Cuándo se abre la puerta de la comunicación todo es posible"',
            memberName: 'Lic. Viviana Juárez',
            memberRole: 'Fonoaudióloga',
            memberTitle: 'Profesional - Rayces',
            showOrder: 9,
            type: 'team',
        },
        {
            image: Team24,
            alt: 'Team member',
            words: '',
            memberName: 'Lic. Lucia Cavallero',
            memberRole: 'Psicomotricista',
            memberTitle: 'Profesional - Rayces',
            showOrder: 10,
            type: 'team',
        },
        {
            image: Team25,
            alt: 'Team member',
            words: '',
            memberName: 'Lic. Pilar Seppi',
            memberRole: 'Psicóloga',
            memberTitle: 'Profesional - Rayces',
            showOrder: 11,
            type: 'team',
        },
        {
            image: Team26,
            alt: 'Team member',
            words: '',
            memberName: 'Lic. Agustina Martinez',
            memberRole: 'Psicóloga',
            memberTitle: 'Profesional - Rayces',
            showOrder: 12,
            type: 'team',
        },
        {
            image: Team27,
            alt: 'Team member',
            words: '',
            memberName: 'Lic. Jimena Paola Grifasi',
            memberRole: 'Fonoaudióloga',
            memberTitle: 'Profesional - Rayces',
            showOrder: 13,
            type: 'team',
        },
        {
            image: Team28,
            alt: 'Team member',
            words: '',
            memberName: 'Lic. Juan Pablo Jerez',
            memberRole: 'Psicólogo',
            memberTitle: 'Profesional - Rayces',
            showOrder: 14,
            type: 'team',
        },
        {
            image: Team29,
            alt: 'Team member',
            words: '',
            memberName: 'Lic. María Belen Gerstner',
            memberRole: 'Musicoterapeuta',
            memberTitle: 'Profesional - Rayces',
            showOrder: 15,
            type: 'team',
        },
        {
            image: Team30,
            alt: 'Team member',
            words: '',
            memberName: 'Lic. Noelia Lopez Pasaresi',
            memberRole: 'Psicopedagóga',
            memberTitle: 'Profesional - Rayces',
            showOrder: 16,
            type: 'team',
        },
        {
            image: Team22,
            alt: 'Team member',
            words: 'En RAYCES queremos dar siempre un mejor servicio de atención. Desde mi lugar, ayudo y acompaño a las profesionales y a las familias para que con una buena organización podamos brindar una respuesta a las necesidades de los niños en tratamiento',
            memberName: 'Cecilia González',
            memberRole: 'Asistente de equipo',
            memberTitle: 'Equipo Rayces',
            showOrder: 17,
            type: 'team',
        },
/* ====================== MAESTRAS ======================= */
        {
            image: Teacher01,
            alt: 'Maestra',
            memberName: '???',
            memberRole: 'Maestra Inclusora',
            showOrder: 1,
            type: 'teacher',
        },
        {
            image: Teacher02,
            alt: 'Maestra',
            words: 'Podes tener un título recién obtenido, experiencia o no, conocer todas las teorías y utilizar los mejores recursos, pero a la hora de la entrevista inicial, la mayoría de las veces eso se te olvida y te ganan los nervios. Al menos eso sentía momentos antes de entrar y presentarme frente a las chicas de Rayces. A medida que pasaba el tiempo comencé a sentirme cómoda y muy a gusto con la calidez, seguridad y contención que transmitían. Luego, con el pasar de los días, pude ver, apreciar y entender cuánto se esfuerzan por lograr un trabajo en equipo, en el que sos parte, ¡y te sentís parte!, en donde se hace todo lo posible por ofrecer lo mejor a los niños, familias y escuelas. Hoy por hoy me encanta mi trabajo, me encanta acompañar a los chicos y sentir que sus logros son los míos y aunque a veces las cosas se ponen un poco difíciles no tenemos que bajar los brazos, porque esto recién comienza y somos nosotros quienes impulsamos el cambio para lograr una sociedad inclusiva',
            memberName: 'Dalma Delgado',
            memberRole: 'Maestra Inclusora',
            showOrder: 2,
            type: 'teacher',
        },
        {
            image: Teacher03,
            alt: 'Maestra',
            memberName: '???',
            memberRole: 'Maestra Inclusora',
            showOrder: 3,
            type: 'teacher',
        },
        {
            image: Teacher04,
            alt: 'Maestra',
            memberName: '???',
            memberRole: 'Maestra Inclusora',
            showOrder: 4,
            type: 'teacher',
        },
        {
            image: Teacher05,
            alt: 'Maestra',
            words: 'EXPERIENCIA RAYCES.. DESAFIO RAYCES… CRECIMIENTO RAYCES… SUEÑO RAYCES…. podría empezar este relato de tantas maneras y todas ellas serian apropiadas. Cuando hace 5 años me convocaron para formar parte de este proyecto, me encontré con un grupo de soñadoras "profesionales" que lograron materializar una hermosa idea , simplemente creyeron que era posible construir un lugar donde la familia encuentre un espacio donde sus niños no solo contaran con terapias , sino un lugar donde ellos vengan contentos, animados, entusiasmados … un lugar donde el aprender sea divertido , puedan tener amigos y sobre todas las cosas sentirse queridos , valorados y respetados en sus tiempos , en sus ritmos y estilos de aprendizajes.El trabajo que me toco desempeñar en Rayces es el de maestra de apoyo a la integración. Estaba acostumbrada a trabajar de manera individual con mis pacientes en consultorio y cuando tuve la oportunidad de trabajar con un equipo fue de manera circunstancial, esto implicaba un reto personal y lo acepté con todos los temores y expectativas que lo nuevo provoca. Ser maestra de apoyo es una tarea muy gratificante, ya que nos permite vivir en primera persona el día a día del niño en el aula, pero también implica una gran responsabilidad por que debemos establecer cuál es nuestra labor , ya que en el imaginario de los docentes e instituciones nuestra intervención aun es poco clara: ¨somos las maestras particulares del niño integrado¨, ¨ estamos para controlar o evaluar el trabajo de la docente de grado¨, somos ¨niñeras¨, es por eso que para evitar todo tipo de inconveniente es importante dejar bien delimitado el encuadre de nuestro trabajo en el aula: somos maestras de apoyo que colaboramos, brindamos estrategias y proponemos un trabajo en conjunto con la maestra de grado ,ella es la maestra integradora, el niño es su alumno y debe recibir la misma atención y dedicación que el resto de sus compañeros. Durante este camino tuve el agrado de conocer a varias familias, escuelas, docentes y lo más importante a los NIÑOS con los que no solo compartí varios años de su trayectoria escolar, sino que los vi crecer, superarse, romper barreras y etiquetas, mis HÉROES. Gracias por enseñarme que lo importante es seguir luchando y que cada día esconde un reto que superar. Hoy 5 años después puedo decir que RAYCES no solo es el lugar donde trabajo, es ¨ el lugar¨ que me recuerda que los deseos y proyectos pueden hacerse realidad cuando se trabaja con AMOR por la profesión que se ha elegido y cuando hay un equipo comprometido. Gracias a cada una de ustedes por confiar en mi trabajo, esta experiencia ayudo a mi crecimiento profesional, me dio herramientas invalorables que hoy me sirven de pilar en la práctica de mi profesión y por ello sigo comprometida con RAYCES. Abrazo enorme. Lorena',
            memberName: 'Lorena Nieva',
            memberRole: 'Maestra Inclusora',
            showOrder: 5,
            type: 'teacher',
        },
        {
            image: Teacher06,
            alt: 'Maestra',
            memberName: '???',
            memberRole: 'Maestra Inclusora',
            showOrder: 6,
            type: 'teacher',
        },
        {
            image: Teacher07,
            alt: 'Maestra',
            memberName: '???',
            memberRole: 'Maestra Inclusora',
            showOrder: 7,
            type: 'teacher',
        },
        {
            image: Teacher08,
            alt: 'Maestra',
            memberName: '???',
            memberRole: 'Maestra Inclusora',
            showOrder: 8,
            type: 'teacher',
        },
        {
            image: Teacher09,
            alt: 'Maestra',
            memberName: '???',
            memberRole: 'Maestra Inclusora',
            showOrder: 9,
            type: 'teacher',
        },
        {
            image: Teacher10,
            alt: 'Maestra',
            memberName: '???',
            memberRole: 'Maestra Inclusora',
            showOrder: 10,
            type: 'teacher',
        },
        {
            image: Teacher11,
            alt: 'Maestra',
            memberName: '???',
            memberRole: 'Maestra Inclusora',
            showOrder: 11,
            type: 'teacher',
        },
        {
            image: Teacher12,
            alt: 'Maestra',
            memberName: '???',
            memberRole: 'Maestra Inclusora',
            showOrder: 12,
            type: 'teacher',
        },
        {
            image: Teacher13,
            alt: 'Maestra',
            memberName: '???',
            memberRole: 'Maestra Inclusora',
            showOrder: 13,
            type: 'teacher',
        },
        {
            image: Teacher14,
            alt: 'Maestra',
            memberName: '???',
            memberRole: 'Maestra Inclusora',
            showOrder: 14,
            type: 'teacher',
        },
        {
            image: Teacher15,
            alt: 'Maestra',
            memberName: '???',
            memberRole: 'Maestra Inclusora',
            showOrder: 15,
            type: 'teacher',
        },
        {
            image: Teacher16,
            alt: 'Maestra',
            memberName: '???',
            memberRole: 'Maestra Inclusora',
            showOrder: 16,
            type: 'teacher',
        },
        {
            image: Teacher17,
            alt: 'Maestra',
            memberName: '???',
            memberRole: 'Maestra Inclusora',
            showOrder: 17,
            type: 'teacher',
        },
        {
            image: Teacher18,
            alt: 'Maestra',
            memberName: '???',
            memberRole: 'Maestra Inclusora',
            showOrder: 18,
            type: 'teacher',
        },
        {
            image: Teacher19,
            alt: 'Maestra',
            memberName: '???',
            memberRole: 'Maestra Inclusora',
            showOrder: 19,
            type: 'teacher',
        },
    ];

export default TeamAssets2025;